module.exports = __webpack_public_path__ + "static/media/nutritionist-dashboard-3.018e91a2.png";